import styled, { css } from 'styled-components';
import { DEVICE_TYPE } from '../constants/sizes';
import { MEDIA_QUERY_DEVICE } from '../constants/media-queries';
const mediaQueryColumn = ({ type, columnSize, position }) => css `
    @media ${MEDIA_QUERY_DEVICE[type]} {
        display: ${columnSize === 0 ? 'none' : 'block'};
        grid-column: ${!!position && `${position} /`}span ${columnSize ? columnSize : 1};
    }
`;
const ResponsiveColumnStyles = (columnProps) => css `
    ${mediaQueryColumn({ type: DEVICE_TYPE.MOBILE, columnSize: columnProps.mobileSize, position: columnProps.mobilePosition })}
    ${mediaQueryColumn({ type: DEVICE_TYPE.TABLET, columnSize: columnProps.tabletSize, position: columnProps.tabletPosition })}
    ${mediaQueryColumn({ type: DEVICE_TYPE.DESKTOP, columnSize: columnProps.desktopSize, position: columnProps.desktopPosition })}
    ${mediaQueryColumn({ type: DEVICE_TYPE.DESKTOP_HD, columnSize: columnProps.desktopHdSize, position: columnProps.desktopHdPosition })}
`;
export const Column = styled.div `
    ${(columnProps) => ResponsiveColumnStyles(columnProps)}
`;
//# sourceMappingURL=Column.styled.js.map